<template>
  <div class="footer soulody">
    <div class="header translucent-6">
      <h2 v-for="(value, index) in values" :key="index">{{ value }}</h2>
    </div>
    <main class="text--grey-darken-1">
      <img :src="logoImg" :alt="$t('homepage.footer.logo.alt')" />
      <h5 v-html="addNbsp($t('homepage.footer.about'))" />
      <div class="footer-links">
        <a
          v-for="(link, index) in navLinks"
          :key="index"
          :href="link.href"
          target="_blank"
          @click.stop="
            gtmPush({
              event: 'button_click',
              link_text: link.label,
              link_location: 'footer'
            })
          "
        >
          <h6>{{ link.label }}</h6>
        </a>
      </div>
      <aside>
        <a
          v-for="(link, index) in asideLinks"
          :key="index"
          :href="link.href"
          target="_blank"
          @click.stop="
            gtmPush({
              event: 'button_click',
              link_text: link.label,
              link_location: 'footer'
            })
          "
        >
          <img :src="link.img" :alt="link.label" />
        </a>
      </aside>
    </main>
    <nav>
      <h6 class="text--grey-darken-1">
        © 2007-{{ currentYear }} {{ $t('homepage.footer.copyright')
        }}<span class="mobile-hidden">, ISSN 1802-5544</span>
      </h6>
      <h6 class="text--grey-darken-1 mobile-shown">ISSN 1802<span></span>-5544</h6>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HomepageFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },
  computed: {
    logoImg() {
      return this.$asset(
        `img/logo${this.$domainRegion !== 'cz' ? `-${this.$domainRegion}` : ''}.svg`
      );
    },
    values() {
      return this.$t('homepage.footer.value', {}, { returnObjects: true });
    },
    asideLinks() {
      const links = Array.from(this.$t('homepage.footer.aside.link', {}, { returnObjects: true }));

      return links
        .filter(link => link && link.href)
        .map(link => ({
          ...link,
          img: this.$asset(`homepage/img/icons/${link.img}`)
        }));
    },
    navLinks() {
      return this.$t('homepage.footer.nav.link', {}, { returnObjects: true });
    }
  }
};
</script>

<style lang="scss" scoped>
.footer.soulody {
  display: grid;
  grid-template-columns: 400px auto 340px;
  grid-template-rows: auto auto;
  grid-template-areas:
    'header . texts'
    'footer footer footer';
  row-gap: 96px;
  width: 100%;
  box-sizing: border-box;
  background-color: #e1e2dd;
  padding: 96px 96px 72px;

  h2 {
    font-size: 72px;
    line-height: 72px;

    @media screen and (max-width: 930px) {
      font-size: 32px;
      line-height: 32px;
    }
  }

  h5 {
    font-size: 16px;
    line-height: 22.4px;

    @media screen and (max-width: 930px) {
      font-size: 14px;
      line-height: 21px;
    }
  }

  h6 {
    font-size: 14px;
    line-height: 21px;
  }

  .text--grey-darken-1 {
    color: #757575;
  }

  .translucent-6 {
    opacity: 0.6;
  }

  @media screen and (max-width: 930px) {
    padding: 48px 24px 40px;
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      'header'
      'texts'
      'footer';
    row-gap: 56px;
  }

  > .header {
    grid-area: header;
    display: flex;
    flex-direction: column;
    text-align: left;
    @media screen and (max-width: 930px) {
      text-align: center;
    }
  }

  > main {
    grid-area: texts;
    display: flex;
    flex-direction: column;
    align-self: start;
    align-items: start;

    > h5 {
      @media screen and (max-width: 930px) {
        text-align: center;
        max-width: 360px;
      }
    }

    > *:not(:first-child) {
      margin-top: 32px;
    }

    > img {
      width: 90px;
      height: auto;
    }

    @media screen and (max-width: 930px) {
      width: 100%;
      text-align: center;
      align-items: center;
    }

    > .footer-links {
      a {
        text-decoration: none;
        color: var(--primary);
        display: block;
        margin-top: 0;

        @media screen and (max-width: 930px) {
          &:not(:first-child) {
            margin-top: 8px;
          }
        }
      }
    }

    > aside {
      display: flex;
      margin-top: 10px;
      padding: 10px;
      gap: 32px;

      a {
        text-decoration: none;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  > nav {
    grid-area: footer;
    display: flex;
    justify-content: space-between;
    align-items: start;

    @media screen and (max-width: 930px) {
      flex-direction: column;
      align-items: center;
      justify-content: start;
    }

    .mobile-hidden {
      display: inline;

      @media screen and (max-width: 930px) {
        display: none;
      }
    }

    .mobile-shown {
      display: none;
      margin-bottom: 48px;

      @media screen and (max-width: 930px) {
        display: block;
      }
    }
  }
}
</style>
